import { Action as StationInfoAction } from '../actions/station-info';
import { Action as NearbyAction } from '../actions/nearby';
import { Action as FavoriteListsAction } from '../actions/favorites';
import { mergeReducer, uniqueReducer } from '../../lib/utils';

const defaultState = {
  isFetching: false,
  stationsById: {},
  stationsByLocation: {},
  isSavingOutage: false,
  isFetchingEmergencyStatus: false,
  error: undefined,
};

export default function stationInfoReducer(state = defaultState, action) {
  const { stationsById, stationsByLocation } = { ...state };
  const body = action?.payload;

  switch (action?.type) {
    case StationInfoAction.StationInfo.StationInfoClear:
      return defaultState;

    case NearbyAction.Nearby.NearbyCompleted:
      return {
        ...state,
        stationsById: body.stations.reduce(mergeReducer('id'), stationsById),
      };

    case StationInfoAction.StationInfo.BrandStationsPending:
    case StationInfoAction.StationInfo.StationInfoPending:
    case StationInfoAction.StationInfo.StationSearchPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    case StationInfoAction.StationInfo.StationSearchCompleted:
      return {
        ...state,
        isFetching: false,
        stationsById: body.stations?.reduce(mergeReducer('id'), stationsById),
        stationsByLocation: {
          ...stationsByLocation,
          ...body.key && body.stations && {
            [body.key]: {
              stations: ((stationsByLocation[body.key] || {}).stations || [])
                .concat(body.stations.map(s => s.id))
                .reduce(uniqueReducer, []),
              nextCursor: body.nextCursor,
              count: body.count,
            },
          },
        },
      };

    case StationInfoAction.StationInfo.StationSearchFailed:
    case StationInfoAction.StationInfo.BrandStationsFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case StationInfoAction.StationInfo.StationInfoCompleted:
      return {
        ...state,
        isFetching: false,
        stationsById: {
          ...state.stationsById,
          [body.id]: body,
        },
      };

    case StationInfoAction.StationInfo.StationInfoFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case StationInfoAction.StationInfo.BrandStationsCompleted:
      return {
        ...state,
        isFetching: false,
        stationsById: body.stations?.reduce(mergeReducer('id'), stationsById),
      };

    case StationInfoAction.Station.OutageUpdatePending:
      return {
        ...state,
        error: undefined,
        isSavingOutage: true,
      };

    case StationInfoAction.Station.OutageUpdateCompleted:
      return {
        ...state,
        isSavingOutage: false,
      };

    case FavoriteListsAction.Favorites.FetchFavoriteStationsCompleted:
      return {
        ...state,
        ...body.stations.reduce((map, station) => {
          map[station.id] = station;
          return map;
        }, {}),
      };

    default:
      return state;
  }
}
